export const MeasurementRange = {
  DayInHours: 'day-in-hours',
  WeekInDays: 'week-in-days',
  MonthInDays: 'month-in-days',
  YearInMonths: 'year-in-months',
  TenYearsInYears: 'ten-years-in-years',
} as const;

export type MeasurementRange = (typeof MeasurementRange)[keyof typeof MeasurementRange];

export interface RangeFromTo {
  from: string;
  to: string;
}

export interface DataPerMeasurementRange {
  format: string;
  onNext: (value: Date) => number;
  onPrev: (value: Date) => number;
}

export interface DatePickerFormat {
  [key: string]: DataPerMeasurementRange;
}

export interface ColorPair {
  dark: string;
  light: string;
  name?: string;
}

export interface ChartDataPoint {
  name: string;
  date?: number;
  time?: string;
  FORWARD_ACTIVE_ENERGY?: number;
  PREDICTION_FORWARD_ACTIVE_ENERGY?: number;
  DYNAMIC_ENERGY_MARKET_PRICE?: number;
  PRICE?: number;
  COST?: number;
  actualProduction?: number;
  prediction?: number;
  [key: string]: string | number | undefined | null;
}

export interface DynamicPrice {
  hour: number;
  price: number;
}

export interface ParametersData {
  [key: string]: {
    unit: string;
    fixed: number;
    color: ColorPair;
  };
}

export const AvailableShortFormatEnum = {
  HOURLY: 'HH:mm',
  WEEKLY: 'EEEEEE',
  MONTHLY: 'dd.LL',
  YEARLY: 'LL',
  TEN_YEARS: 'yyyy',
} as const;

export type AvailableShortFormatEnum = (typeof AvailableShortFormatEnum)[keyof typeof AvailableShortFormatEnum];

export const AvailableLongFormatEnum = {
  HOURLY: 'HH:mm',
  WEEKLY: 'eeee, dd.MM',
  MONTHLY: 'dd.LL.yyyy',
  YEARLY: 'LLLL',
  TEN_YEARS: 'yyyy',
} as const;

export type AvailableLongFormatEnum = (typeof AvailableLongFormatEnum)[keyof typeof AvailableLongFormatEnum];

export const ClusterViewType = {
  BAR_CHART: 'bar-chart',
  PIE_CHART: 'pie-chart',
  TABLE: 'table',
} as const;

export type ClusterViewType = (typeof ClusterViewType)[keyof typeof ClusterViewType];